// extracted by mini-css-extract-plugin
module.exports = {"iframe-dialog--body":"iframe-dialog--body__3mxnz","iframe-dialog--iframe":"iframe-dialog--iframe__34IE9"};